export default __webpack_public_path__ + "static/media/article2.7fe0c58a.jpg";